import React, { useState } from 'react';
import { Link } from 'react-router-dom';
//import logo from '../FINAL Logo.png';
import './Header.css';

const logo = "/images/FINAL_Logo.png"

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <Link to="/" onClick={closeMenu}>
        <img src={logo} alt="Consumer Equity Legal" className="logo" />
      </Link>
      
      <button 
        className="menu-button" 
        onClick={toggleMenu}
        aria-label="Toggle navigation menu"
      >
        {isMenuOpen ? '✕' : '☰'}
      </button>

      <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
        <Link to="/" onClick={closeMenu}>Home</Link>
        <Link to="/about" onClick={closeMenu}>About</Link>
        <Link to="/practice-areas" onClick={closeMenu}>Practice Areas</Link>
        <Link to="/team" onClick={closeMenu}>Meet The Team</Link>
        <Link to="/blog" onClick={closeMenu}>Blog</Link>
        <Link to="/client-intake" className="cta-button" onClick={closeMenu}>Client Intake</Link>
      </nav>
    </header>
  );
};

export default Header;